(function () {
  'use strict';

  function initSlider(root) {
    var slides = Array.prototype.slice.call(root.querySelectorAll('.hero-slide'));
    if (slides.length < 2) return;

    var dots = Array.prototype.slice.call(root.querySelectorAll('.hero-slider__dot'));
    var prevBtn = root.querySelector('.hero-slider__arrow--prev');
    var nextBtn = root.querySelector('.hero-slider__arrow--next');

    var current = 0;
    var autoplay = root.dataset.autoplay === 'true';
    var speed = (parseInt(root.dataset.autoplaySpeed, 10) || 6) * 1000;
    var timer = null;

    function goTo(index) {
      index = (index + slides.length) % slides.length;
      slides[current].classList.remove('is-active');
      slides[current].setAttribute('aria-hidden', 'true');
      dots[current] && dots[current].classList.remove('is-active');

      current = index;

      slides[current].classList.add('is-active');
      slides[current].setAttribute('aria-hidden', 'false');
      dots[current] && dots[current].classList.add('is-active');
    }

    function next() { goTo(current + 1); }
    function prev() { goTo(current - 1); }

    function startAutoplay() {
      if (!autoplay) return;
      stopAutoplay();
      timer = setInterval(next, speed);
    }

    function stopAutoplay() {
      if (timer) clearInterval(timer);
    }

    nextBtn && nextBtn.addEventListener('click', function () {
      next();
      startAutoplay();
    });

    prevBtn && prevBtn.addEventListener('click', function () {
      prev();
      startAutoplay();
    });

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        goTo(i);
        startAutoplay();
      });
    });

    root.addEventListener('mouseenter', stopAutoplay);
    root.addEventListener('mouseleave', startAutoplay);

    // basic swipe support for touch devices
    var touchStartX = 0;
    root.addEventListener('touchstart', function (e) {
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });

    root.addEventListener('touchend', function (e) {
      var touchEndX = e.changedTouches[0].screenX;
      var diff = touchEndX - touchStartX;
      if (Math.abs(diff) > 40) {
        diff < 0 ? next() : prev();
        startAutoplay();
      }
    }, { passive: true });

    startAutoplay();
  }

  function init() {
    document.querySelectorAll('.hero-slider').forEach(initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var slider = e.target.querySelector && e.target.querySelector('.hero-slider');
    if (slider) initSlider(slider);
  });
})();
